module.exports = __webpack_public_path__ + "img/about_company.d0ede439.jpg";